import router from './router'
import Router from 'vue-router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

NProgress.configure({showSpinner: false}) // NProgress Configuration
const whiteList = ['/login','']

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

router.beforeEach(async (to, from, next) => {
    const defLogin = async () => {
        if (to.path != '/login' && to.path != '/goMain') {
            if(!store.state.loginInfo){
                let param = {
                    url:"/main/index",
                }
                const data = await store.dispatch('pubMethod', param)
                store.state.loginInfo = data.data;

                param = {
                    url:"/head/getInfo",
                }
                const ret = await store.dispatch('pubMethod', param);

                param = {
                    url:"/dictionaries/list",
                    param:{
                        parentId:"act002",
                        pageSize:"100",
                        currentPage:"1",
                    }
                }
                const flowData = await store.dispatch('pubMethod', param);
                store.state.flowTypeList = flowData.data.varList;
            }
            next();
        } else if (to.path === '/goMain') {

            let query = to.query;

            //生成随机token
            var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
            var maxPos = $chars.length;
            var returnStr = '';
            for (var i = 0; i < 32; i++) {
                returnStr += $chars.charAt(Math.floor(Math.random() * maxPos));
            }
            let token = returnStr;
            let param = {
                url:"/login/goMain",
                param:{
                    "token": token,
                    "loginName": query.loginName,
                    "secret": query.secret,
                }
            };

            const data = await store.dispatch('pubMethod', param);
            if (data.infoCode === '0') {

                localStorage.setItem('token', token);
                localStorage.setItem('loginName', query.loginName);
                await router.push({path: '/main'})
            }

            next();
        } else {
            delete store.state.loginInfo;
            next()
        }
    }
    NProgress.start();
    await defLogin();
})
router.afterEach(() => {
    // 完成进度条
    NProgress.done()
});
